import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import Reports from '../../components/reports/Reports'
import Footer from '../../components/common/Footer'
export default function ReportsPage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <Reports />
            <Footer />
        </>
    )
}
